import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout';
import { AdminRoutes, LogisticsRoutes, UserRoutes } from '@/models/appRoutes';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./public/public.routes').then((m) => m.routes),
      },
      {
        path: UserRoutes.Root,
        loadChildren: () => import('./user/user.routes').then((m) => m.routes),
        canActivateChild: [AuthGuard],
      },
      {
        path: AdminRoutes.Root,
        loadChildren: () => import('./admin/admin.routes').then((m) => m.routes),
        canActivateChild: [AuthGuard],
      },
      {
        path: LogisticsRoutes.Root,
        loadChildren: () => import('./modules/logistics/logistics.routes').then((m) => m.routes),
        canActivateChild: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: `/${UserRoutes.Root}`,
  },
];
